import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { BorderedTablePaper } from "@/pages/heat-report/styles/HeatReportStyledComponents";
import { Box } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useTableData } from "./hooks/useTableData";
import { defaultColDef, defaultGridOptions } from "@/setup/ag-grid/mesf-theme";

export const InjectionsTable = () => {
  const {
    state: { injections, eafProcessData },
  } = useHeatReportContext();

  const { columns } = useTableData();
  return (
    <BorderedTablePaper elevation={0}>
      <Box p={1}>
        <div
          style={{ height: "20rem" }}
          key={`${injections.length}-${eafProcessData.ProcessId}`}
        >
          <AgGridReact
            rowData={injections}
            columnDefs={columns}
            defaultColDef={{ ...defaultColDef, sortable: false }}
            getRowId={(params) => params.data.InjectionTypeId}
            {...defaultGridOptions}
          />
        </div>
      </Box>
    </BorderedTablePaper>
  );
};
